import React, { useState } from "react";
import GreyInfo from "../../../../merchant/panel/scripts/shared/greyInfo/greyInfo.js";
import DataLabel from "../../../../merchant/panel/components/dataLabel/dataLabel.js";
import Config from "../../../config/mainConfig.js";
import Currency from "../../../sharedScripts/Currency.js";
export default function Main(props) {
    const [amount, setAmount] = useState(0);
    const calculatedPrice = new Currency(amount * Config.FEE_PERCENTAGE).toString();
    return (React.createElement("main", { className: "price-list-container landing-page-main" },
        React.createElement("div", { className: "price-list-container-box" },
            React.createElement("section", { className: "price-list-box" },
                React.createElement("h2", null, "Cennik Fotohub"),
                React.createElement(GreyInfo, null, "Nie pobieramy op\u0142at od tworzenia galerii. Otrzymasz r\u00F3wnie\u017C 20 z\u0142otych do wykorzystania w aplikacji w momencie utworzenia konta."),
                React.createElement("br", null),
                React.createElement("h3", null, "Galerie:"),
                React.createElement(DataLabel, { label: "Procent od kwoty z\u0142o\u017Conego zam\u00F3wienia", responsive: true, importantData: true, type: "horizontal-no-line" },
                    React.createElement("b", { className: "no-wrap-text" },
                        Config.FEE_PERCENTAGE * 100,
                        "%")),
                React.createElement(DataLabel, { label: "Pobranie zdj\u0119cia w pe\u0142nym rozmiarze", responsive: true, importantData: true, type: "horizontal-no-line" },
                    React.createElement("b", { className: "no-wrap-text" },
                        " ",
                        Config.COST_PER_FULL_IMAGE_DOWNLOAD * 0.01,
                        "z\u0142")),
                React.createElement("h3", null, "Kolekcje"),
                React.createElement(DataLabel, { label: "Wej\u015Bcie do kolekcji", responsive: true, importantData: true, type: "horizontal-no-line" },
                    React.createElement("b", { className: "no-wrap-text" },
                        Config.COST_PER_COLLECTION_VISIT * 0.01,
                        "z\u0142"))))));
}
